import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import styled from 'styled-components'

export const StepWrapper = styled.div`
  display: flex;
  flex-direction: column;
  width: 100%;
  border-radius: 20px;
  background:  rgba(255, 255, 255, 0.44);
  padding: 20px;
  margin: 16px 0 0 0;
`

export const ToolText = styled.p`
  font-size: 1em;
  color: white;
  font-family: 'proxima-nova', sans-serif;
  letter-spacing: 0.02em;
  white-space: pre-wrap;
  font-weight: 700;
`

export const ActionContainer = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: flex-start;
`

export const CopyContainer = styled.div<{ windowWidth: number }>`
  display: flex;
  flex-direction: ${({ windowWidth }) =>
    windowWidth < 500 ? 'column' : 'row'};
  align-items: center;
  justify-content: flex-start;
  position: relative;
  width: fit-content;
`
export const CopyLinkInput = styled.input<{ windowWidth: number }>`
  height: 55px;
  background: #ffffff;
  color: #9a989e;
  border: 1px dashed #9a989e;
  padding: 12px;
  border-radius: 8px;
  user-select: text;
  margin: ${({ windowWidth }) =>
    windowWidth < 500 ? '0 0 4px 0' : '0 8px 0 0'};
  &:hover {
    cursor: text;
  }
`

export const CopyButton = styled.button<{ windowWidth: number }>`
  background: #345dd4;
  border-radius: 10px;
  border: none;
  padding: 8px;
  height: 45px;
  margin: ${({ windowWidth }) => (windowWidth < 500 ? '2px' : '0 4px')};
  &:hover {
    cursor: pointer;
    background: #2e55bf;
  }
`

export const CopyButtonContainer = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: left;
`

export const CopyButtonIcon = styled(FontAwesomeIcon)`
  color: #fff;
  margin: 0 8px;
`

export const CopyButtonText = styled.p`
  font-size: 1em;
  font-family: 'proxima-nova', sans-serif;
  color: #fff;
  letter-spacing: 0.02em;
  white-space: pre-wrap;
  font-weight: 700;
  margin: 0;
`

export const CopyMessage = styled.div<{ isVisible: boolean }>`
  position: absolute;
  height: 30px;
  display: flex;
  border-radius: 6px;
  width: 70px;
  right: -75px;
  background: #0b1226;
  color: #fff;
  justify-content: center;
  align-items: center;
  margin: auto 0;
  opacity: ${isVisible => (isVisible ? 1 : 0)};
  transition: opacity 2s ease-in-out;

  ::before {
    content: '';
    position: absolute;
    top: 50%;
    left: -6px;
    transform: translateY(-50%);
    width: 0;
    height: 0;
    border-top: 10px solid transparent;
    border-bottom: 10px solid transparent;
    border-right: 10px solid #0b1226;
  }
`

export const CopyMessageText = styled.p`
  font-size: 0.75em;
  font-family: 'proxima-nova', sans-serif;
  color: #fff;
  margin: 0;
  font-weight: 700;
`

export const ShareIcon = styled(FontAwesomeIcon)`
  color: #868686;
  margin-right: 8px;
  align-self: center;
`

export const ShareText = styled.p`
  color: #868686;
  font-family: 'proxima-nova', sans-serif;
  align-self: center;
  margin: 0;
`


export const PageWrapper = styled.div`
  display: flex;
  padding: 16px;
  flex-direction: column;
  background: rgb(70, 115, 248);
  min-height: 100vh;
  background: linear-gradient(
    135deg,
    rgba(70, 115, 248, 1) 0%,
    rgba(143, 93, 226, 1) 50%,
    rgba(210, 78, 189, 1) 100%
  );
`

export const FireWorkOverlay = styled.div`
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  pointer-events: none;
  animation: fadeOut 11s ease-in-out forwards;

  @keyframes fadeOut {
    0% {
      opacity: 1;
    }
    100% {
      opacity: 0;
    }
  }
`

export const Logo = styled.img`
  display: block;
  margin: 0 auto;
  max-width: 90%;
  height: 100px;
` 

export const Container = styled.div`
  display: grid;
  grid-template-columns: repeat(auto-fit, 300px);
  gap: 24px;
  justify-content: center;
  padding: 24px;
  max-width: 1700px;
  align-self: center;
  margin: 0 auto;
  width: 100%;
`

export const Title = styled.h1`
  margin-bottom: 24px;
  width: 100%;
  color: white;
  text-align: center;
  font-size: 4em;
  padding: 0 16px;
  font-weight: 600;
`

export const ButtonGroup = styled.div`
    width: fit-content;
`
